<template>
  <article class="document_card document-card document-card_full" ref="rootElem">
    <h1 class="dc-full__title">{{ title }}</h1>

    <div
      v-if="!card.hasAccessFull()"
      class="message _warning dc__item dc__access"
    >
      Ограничение доступа: {{ card.accessComment }}
    </div>

    <div v-if="card.designation" class="dc__designation _full-card">
      <span class="snippet__designation">
        {{ card.designation }}
      </span>
    </div>
    <div v-else-if="card.type || card.number" class="dc__designation _full-card">
      <span class="snippet__designation">
        {{ card.type }}&nbsp;{{ card.number }}
      </span>
    </div>

    <template v-if="card.isChange">
      <div class="dc__item">
        <p :style="{ color: card.isChangeCanceled() ? 'red' : 'inherit' }">
          {{ card.statusHint }}
        </p>
      </div>

      <div v-if="card.parentDocumentId" class="dc__item">
        <div class="dc-item__label">Изменяемый документ</div>
        <div class="dc__item">
          <router-link
            :to="makeDocumentRoute(card.parentDocumentId)"
            v-text="card.parentDocumentTitle"
          />
        </div>
      </div>
    </template>

    <template v-if="card.isAttachment">
      <div v-if="card.parentDocumentId" class="dc__item">
        <div class="dc-item__label">Документ</div>
        <div class="dc__item">
          <router-link
            :to="makeDocumentRoute(card.parentDocumentId)"
            v-text="card.parentDocumentTitle"
          />
        </div>
      </div>
    </template>

    <div v-if="card.synonyms.length > 0" class="dc__item dc-item__synonyms">
      <div>
        <span
          v-for="(item, index) in card.synonyms"
          v-if="index <= count"
          :key="index"
          class="dc-item__synonyms-item AddComma()"
        >{{ item }}</span
        >
      </div>
      <a
        v-if="card.synonyms.length > 4 && count <= 4"
        href="#"
        class="dc-show-more__link"
        @click="changeCountOfSynomys(card.synonyms.length - 1)"
      >Показать все</a
      >
      <a
        v-if="count > 4"
        href="#"
        class="dc-show-more__link"
        @click="changeCountOfSynomys(4)"
      >Скрыть</a
      >
    </div>

    <div v-if="card.title" class="dc__item">
      <div class="dc-item__label">{{ name }}</div>
      <div class="dc__name _full-card">{{ card.title }}</div>
    </div>

    <list-items
      v-if="card.approvedText.length"
      v-slot="{ item }"
      :items="card.approvedText"
      class="dc__item dc__list dc__approved"
      title="Утвержден"
    ></list-items>

    <list-items
      v-if="card.agreed.length"
      v-slot="{ item }"
      :items="card.agreed"
      class="dc__item dc__list dc__approved"
      title="Согласован"
    ></list-items>

    <div v-if="card.hasAnnotation" class="dc-item__label" :ref="targetAnnotationId">
        Примечания и особенности применения
    </div>
    <div v-if="card.hasAnnotation"
      id="annotation"
      class="dc__item dc__continuity"
    >
      <div v-if="isLoading.annotation">Загрузка...</div>
      <div v-else-if="loadErrors.annotation.status" class="message _error">
        Ошибка: {{ loadErrors.annotation.message }}
      </div>
      <iframe
        v-else
        ref="annotationFrame"
        class="dc__iframe"
        src="about:blank"
      ></iframe>
    </div>

    <list-items
      v-if="card.authors.length"
      v-slot="{ item }"
      :items="card.authors"
      class="dc__item dc__list dc__authors"
      title="Разработчики"
    ></list-items>

    <list-items
      v-if="card.publications.length"
      v-slot="{ item }"
      :items="card.publications"
      class="dc__item dc__list dc__publications"
      title="Сведения о публикациях"
    ></list-items>

    <div
      v-if="card.area"
      class="dc__item"
      :class="{ _collapsed: card.area.length > 400 }"
    >
      <div class="dc-item__label">Область применения</div>
      <div
        class="dc-item__content"
        :class="{ _opened: cardAreaOpened }"
        v-html="card.area"
      ></div>
      <div
        class="dc__show-more _full-card"
        :class="{ _opened: cardAreaOpened }"
      >
        <!-- TODO: сделать отдельный компонент на открытие -->
        <a
          class="dc-show-more__link"
          href="#"
          @click.prevent="cardAreaOpened = !cardAreaOpened"
        >{{ cardAreaOpened ? 'Свернуть' : 'Показать все' }}</a
        >
      </div>
    </div>

    <div
      v-if="card.comment"
      id="comment"
      class="dc__item"
      :class="{ _collapsed: card.comment.length > 500 }"
    >
      <div class="dc-item__label">Комментарий</div>
      <div
        class="dc-item__content"
        :class="{ _opened: cardCommentOpened }"
        v-html="card.comment"
      ></div>
      <div
        class="dc__show-more _full-card"
        :class="{ _opened: cardCommentOpened }"
      >
        <a
          class="dc-show-more__link"
          href="#"
          @click.prevent="cardCommentOpened = !cardCommentOpened"
        >{{ cardCommentOpened ? 'Свернуть' : 'Показать все' }}</a
        >
      </div>
    </div>

    <list-items
      v-if="relationsInstead.length"
      v-slot="{ item }"
      :items="relationsInstead"
      class="dc__item dc__list dc__relations-instead"
      title="Взамен"
    >
      <router-link :to="makeDocumentRoute(item.id)" v-text="item.title" />
    </list-items>

    <list-items
      v-if="relationsReplaced.length"
      v-slot="{ item }"
      :items="relationsReplaced"
      class="dc__item dc__list dc__relations-replaced"
      title="Заменен на"
    >
      <router-link :to="makeDocumentRoute(item.id)" v-text="item.title" />
    </list-items>

    <div v-if="card.statusHistory.length === 1" class="dc__item">
      <div class="dc-item__label">Статус</div>
      <div>{{ card.statusHistory[0] }}</div>
    </div>

    <div
      v-if="card.statusHistory.length > 1"
      class="dc__item dc__list dc__status-changes"
    >
      <div class="dc-item__label">Изменения статуса</div>
      <ul>
        <li
          v-for="(value, index) in card.statusHistory"
          :key="index"
          class="list-item dc__status"
        >
          <span>{{ value }}</span>
        </li>
      </ul>
    </div>

    <template v-if="!card.isChange && !card.isAttachment">
      <document-card-changes :changes="docChanges" />

      <div v-if="card.project" class="dc__item">
        <div class="message _attention">
          <span>
            {{ projectText }}
            <a :href="card.project.url" target="_blank">{{
              projectLinkText
            }}</a>
          </span>
        </div>
      </div>

      <div
        v-if="card.hasContinuity"
        id="continuity"
        :ref="targetContinuityId"
        class="dc__item dc__continuity"
      >
        <h2 class="dc-full__title">Преемственность</h2>
        <div v-if="isLoading.continuity">Загрузка...</div>
        <div v-else-if="loadErrors.continuity.status" class="message _error">
          Ошибка: {{ loadErrors.continuity.message }}
        </div>
        <iframe
          v-else
          ref="continuityFrame"
          class="dc__iframe"
          src="about:blank"
        ></iframe>
      </div>
      <document-card-classifiers :classifiers="docClassifiers" />
    </template>

    <template v-if="hasSectionLinks">
      <h2 class="dc-full__title">Ссылки</h2>
      <list-items
        v-if="relationsChangedTo.length"
        v-slot="{ item }"
        :items="relationsChangedTo"
        :expandable="3"
        class="dc__item dc__list"
        title="Вносит изменения в следующие документы"
      >
        <router-link :to="makeDocumentRoute(item.id)" v-text="item.title" />
      </list-items>

      <list-items
        v-if="relationsRefersTo.length"
        v-slot="{ item }"
        :items="relationsRefersTo"
        :expandable="3"
        class="dc__item dc__list"
        title="Документ ссылается"
      >
        <router-link :to="makeDocumentRoute(item.id)" v-text="item.title" />
      </list-items>

      <list-items
        v-if="relationsRefersFrom.length"
        v-slot="{ item }"
        :items="relationsRefersFrom"
        :expandable="3"
        class="dc__item dc__list"
        title="На документ ссылаются"
      >
        <router-link :to="makeDocumentRoute(item.id)" v-text="item.title" />
      </list-items>

      <list-items
        v-if="relationsIncludedInChecklists.length"
        v-slot="{ item }"
        :items="relationsIncludedInChecklists"
        :expandable="3"
        class="dc__item dc__list"
        title="Документ входит в перечни"
      >
        <router-link :to="makeDocumentRoute(item.id)" v-text="item.title" />
      </list-items>

      <list-items
        v-if="relationsExpertAnswers.length"
        v-slot="{ item }"
        :items="relationsExpertAnswers"
        :expandable="5"
        class="dc__item dc__list"
        title="Ответы экспертов"
      >
        <router-link :to="makeDocumentRoute(item.id)" v-text="item.title" />
      </list-items>
    </template>

    <div v-if="card.customFields.length" class="dc__item">
      <h2 class="dc-full__title">Дополнительная информация</h2>
      <div v-for="(group, index) in card.customFields" :key="index">
        <div class="dc-item__label">{{ group.label }}:</div>
        <div v-for="(field, index) in group.fields" :key="index">
          {{ field.label }}: {{ field.value }}
        </div>
      </div>
    </div>

    <div class="dc__footer">
      <div>
        Открыть в программе NormaCS 4.x:
        <a :href="card.normacsUrl" id = 'mainNormaCsLink' v-text="card.normacsUrl"></a>
      </div>
      <div v-if="card.dbCreationDate">
        <span>
          Документ добавлен в базу
          <time class="dc__timestamp">{{
            card.dbCreationDate | formatDate
          }}</time>
        </span>
        <span v-if="card.dbUpdateDate">
          , обновлен
          <time class="dc__timestamp">{{
            card.dbUpdateDate | formatDate
          }}</time> </span
        >.
      </div>
    </div>
  </article>
</template>

<script>
import { ROUTE_DOCUMENT_HASH_CONTINUITY } from '@src/routes';
import { ROUTE_DOCUMENT_HASH_ANNOTATION } from '@src/routes';

import { mapGetters } from 'vuex';
import apiDocuments from '@src/api/documents';

import DocumentCardChanges from './DocumentCardChanges';
import DocumentCardClassifiers from './DocumentCardClassifiers';
import ListItems from '@@/shared/list/ListItems';

import DocumentProject from '@@/document/mixins/DocumentProject';
import DocumentRoute from '@@/document/mixins/DocumentRoute';
import NormaCsLinkHandler from '@@/document/mixins/NormaCsLinkHandler';

export default {
  components: {
    ListItems,
    DocumentCardChanges,
    DocumentCardClassifiers
  },

  mixins: [DocumentProject, DocumentRoute, NormaCsLinkHandler],

  props: {
    /** @type {Object|ApiDocumentCard} */
    card: {
      type: Object,
      required: true
    },

    target: {
      type: String,
      default: null
    }
  },

  data: () => ({
    count: 4,
    /** @type {CancelTokenSource|null} */
    loadContinuityCancelSource: null,
    loadAnnotationCancelSource: null,
    cardAreaOpened: false,
    cardCommentOpened: false,
    targetContinuityId: ROUTE_DOCUMENT_HASH_CONTINUITY,
    targetAnnotationId: ROUTE_DOCUMENT_HASH_ANNOTATION,
    bBeg: true
  }),

  computed: {
    ...mapGetters({
      documentId: 'currentDocumentId',
      continuityContent: 'currentDocumentContinuity',
      annotationContent: 'currentDocumentAnnotation',
      docChanges: 'currentDocumentChanges',
      docClassifiers: 'currentDocumentClassifiers',
      isLoading: 'documentIsLoading',
      loadErrors: 'loadErrors'
    }),
    title() {
      return this.card.isChange ? 'Карточка изменения документа' :
        this.card.isAttachment ? 'Карточка приложения к документу' :
        'Карточка документа';
    },
    name() {
      return this.card.isAttachment
        ? 'Имя файла'
        : 'Название';
    },
    /** @returns {Array<ApiDocumentRelation>} */
    relationsInstead() {
      return this.card.getRelationInstead();
    },
    /** @returns {Array<ApiDocumentRelation>} */
    relationsRefersFrom() {
      return this.card.getRelationRefersFrom();
    },
    /** @returns {Array<ApiDocumentRelation>} */
    relationsRefersTo() {
      return this.card.getRelationRefersTo();
    },
    /** @returns {Array<ApiDocumentRelation>} */
    relationsReplaced() {
      return this.card.getRelationReplaced();
    },
    /** @returns {Array<ApiDocumentRelation>} */
    relationsChangedTo() {
      return this.card.getRelationChangedTo();
    },
    /** @returns {Array<ApiDocumentRelation>} */
    relationsIncludedInChecklists() {
      return this.card.getRelationIncludedInChecklists();
    },
    /** @returns {Array<ApiDocumentRelation>} */
    relationsExpertAnswers() {
      return this.card.getRelationExpertAnswers(this.$store.state.dbExpertId);
    },
    hasSectionLinks() {
      return (
        this.relationsRefersTo.length ||
        this.relationsRefersFrom.length ||
        this.relationsIncludedInChecklists.length ||
        this.relationsExpertAnswers.length
      );
    },
    projectText() {
      return this.makeProjectText(this.card.project);
    },
    projectLinkText() {
      return this.makeProjectLinkText(this.card.project);
    }
  },

  watch: {
    async documentId() {
      await this.loadCardData();
    },

    '$route' (to, from) {
        // маршрут меняется
        if (to.path === from.path) {
          // позиционируюсь на нужном элементе
          this.scrollToTarget(to.hash);
        }
        else {
          let i1 = to.path.lastIndexOf("/");
          let i2 = from.path.lastIndexOf("/");
          if (i1 != -1 && i2 != -1) {
            let toBegPath = to.path.substr(1, i1 - 1);
            let fromBegPath = from.path.substr(1, i2 - 1);
            if (toBegPath === fromBegPath)
              // страница обновляется
              this.$router.go(0);
          }
        }
    } 
  },

  async created() {
    await this.loadCardData();
  },

  updated() {
    if (this.bBeg) {
      this.bBeg = false;
      this.initNormaCsLinkHandler(this.$refs.rootElem);
    }
  },

  methods: {
    async loadCardData() {
      let changesPromise = this.$store.dispatch('setCurrentDocumentProperty', {
        name: 'changes'
      });
      let classifiersPromise = this.$store.dispatch(
        'setCurrentDocumentProperty',
        { name: 'classifiers' }
      );

      await changesPromise;
      await classifiersPromise;
      if (this.card.hasContinuity) {
        await this.$store.dispatch('setCurrentDocumentProperty', {
          name: 'continuity'
        });
        this.setContinuityView();
      }

      if (this.card.hasAnnotation) {
        await this.$store.dispatch('setCurrentDocumentProperty', {
          name: 'annotation'
        });
        this.setAnnotationView();
      }
      if (this.target) this.scrollToTarget(this.target);
    },

    changeCountOfSynomys(int) {
      this.count = int;
    },

    setContinuityView() {
      let frame = this.$refs.continuityFrame;

      if (!frame) return;
      let frameDocument = frame.contentWindow.document;
      let cardScrollTop = this.$el.scrollTop;

      frame.onload = () => {
        // Устанавливаем высоту фрейма равной высоте содержимого,
        // чтобы избавиться от вертикальной полосы прокрутки.
        let height = Math.max(
          frameDocument.body.scrollHeight,
          frameDocument.documentElement.scrollHeight
        );
        frame.style.height = `${height}px`;

        // Загрузка фрейма приводит к скроллу карточки документа до фрейма.
        // Возвращаем скролл в исходную позицию.
        this.$el.scrollTop = cardScrollTop;
      };
      let iframeStylesUrl = `${location.protocol}//${
        location.host
      }${__BASE_URL__}iframe-continuity-styles.css`;
      const styleLink = document.createElement('link');

      styleLink.href = iframeStylesUrl;
      styleLink.rel = 'stylesheet';
      styleLink.type = 'text/css';

      frameDocument.write(this.continuityContent);
      frameDocument.head.appendChild(styleLink);
      frameDocument.close();

      this.initNormaCsLinkHandler(frameDocument);
      if (this.target) {
        this.scrollToTarget(this.target);
      }
      let header = frameDocument.getElementById('thisDoc')

      header.children[0].style['font-weight'] = '700'
    },

    setAnnotationView() {
      let frame = this.$refs.annotationFrame;

      if (!frame) return;
      let frameDocument = frame.contentWindow.document;
      let cardScrollTop = this.$el.scrollTop;
      
      frame.onload = () => {
        // Устанавливаем высоту фрейма равной высоте содержимого,
        // чтобы избавиться от вертикальной полосы прокрутки.
        let height = Math.max(
          frameDocument.body.scrollHeight,
          frameDocument.documentElement.scrollHeight
        );
        frame.style.height = `${height}px`;

        // Загрузка фрейма приводит к скроллу карточки документа до фрейма.
        // Возвращаем скролл в исходную позицию.
        this.$el.scrollTop = cardScrollTop;
      };
      let iframeStylesUrl = `${location.protocol}//${
        location.host
      }${__BASE_URL__}iframe-continuity-styles.css`;
      const styleLink = document.createElement('link');

      styleLink.href = iframeStylesUrl;
      styleLink.rel = 'stylesheet';
      styleLink.type = 'text/css';

      frameDocument.write(this.annotationContent);
      frameDocument.head.appendChild(styleLink);
      frameDocument.close();

      this.initNormaCsLinkHandler(frameDocument);
      if (this.target) {
        this.scrollToTarget(this.target);
      }
      let header = frameDocument.getElementById('thisDoc')

      header.children[0].style['font-weight'] = '700'
    },

    scrollToTarget(targetId) {
      //console.log(targetId);
      let target = this.$refs[targetId];
      //console.log(target);
      if (target) {
        // TODO: make it right way
        this.$parent.$refs.documentScroll.scrollTop = target.offsetTop;
        // this.$el.scrollTop = target.offsetTop;
      }
    }
  }
};
</script>
